import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Navigation } from '../../components';
import { STORE_NAV_MENU } from '../../constants';
import { NavMenuStore } from '../../stores';
import './style.css';

export interface NavigationContainerProps {
  /* [STORE_NAV_MENU]: NavMenuStore; */
}

export interface NavigationContainerState {
  /* empty */
}

@inject(STORE_NAV_MENU)
@observer
export class NavigationContainer extends React.Component<
  NavigationContainerProps,
  NavigationContainerState
> {
  render() {
    const navMenuStore = this.props[STORE_NAV_MENU] as NavMenuStore;

    return (
      <Navigation
        items={navMenuStore.navigationItems}
        headerItems={navMenuStore.headerNavigationItems}
        desktopExpandedItem={navMenuStore.desktopExpandedItem}
        mobileExpandedItems={navMenuStore.mobileExpandedItems}
        expanded={navMenuStore.expanded}
        onExpandItem={navMenuStore.expandItem}
        onCollapseItem={navMenuStore.collapseItem}
        onToggleMobileItem={navMenuStore.toggleMobileItem}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/NavigationContainer/index.tsx